import React from 'react';
import { Facebook } from 'lucide-react';
import { siteData } from '../data';

export const FacebookFeed = () => {
  // Encode the Facebook URL for the iframe
  const encodedUrl = encodeURIComponent(siteData.company.facebookUrl);
  const iframeSrc = `https://www.facebook.com/plugins/page.php?href=${encodedUrl}&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`;

  return (
    <div className="bg-zinc-950 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Venstre kolonne: Facebook Iframe */}
          <div className="w-full max-w-[500px] mx-auto lg:mx-0 order-2 lg:order-1">
            <div className="bg-zinc-900 shadow-2xl overflow-hidden rounded-2xl border border-white/10">
              {/* Header */}
              <div className="bg-red-600 p-4 flex items-center justify-between text-white">
                <div className="flex items-center gap-3 w-full px-2">
                  <div className="bg-white p-2 rounded-full shadow-inner">
                    <Facebook className="h-5 w-5 text-red-600 fill-current" />
                  </div>
                  <div>
                    <h3 className="font-bold leading-tight uppercase tracking-wide text-sm">Banh Mi Bowl</h3>
                    <p className="text-[10px] text-red-100">Seneste opdateringer</p>
                  </div>
                </div>
              </div>
              
              {/* Facebook Iframe Container */}
              <div className="bg-zinc-800 flex justify-center min-h-[600px] relative w-full">
                <div className="absolute inset-0 flex items-center justify-center text-zinc-500 text-sm">
                  Indlæser Facebook feed...
                </div>
                <iframe 
                  src={iframeSrc}
                  width="100%" 
                  height="600" 
                  style={{ border: 'none', overflow: 'hidden', width: '100%' }} 
                  scrolling="no" 
                  frameBorder="0" 
                  allowFullScreen={true} 
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title="Facebook Feed"
                  className="w-full relative z-10"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Højre kolonne: Tekst og Knap */}
          <div className="text-center lg:text-left order-1 lg:order-2 space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight leading-tight">
                Følg os på <span className="text-red-600">Facebook</span>
              </h2>
              <p className="text-xl text-zinc-400 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                Få de seneste nyheder, billeder og tilbud direkte i dit feed. Vi opdaterer jævnligt med dagens specialiteter og stemningsbilleder fra butikken.
              </p>
            </div>
            
            <div className="pt-4">
              <a 
                href={siteData.company.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center bg-red-600 text-white py-5 px-10 rounded-full font-bold text-lg uppercase tracking-widest transition-all duration-300 hover:bg-red-700 hover:scale-[1.05] active:scale-[0.98] shadow-xl shadow-red-600/20"
              >
                <Facebook className="mr-3 h-6 w-6 fill-current" />
                Besøg vores Facebook-side
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
